import React from 'react';
import TwoFactorForm from './TwoFactorForm';
import SecondaryButton from 'components/buttons/SecondaryButton';
import logoGrey from 'assets/crafter-logo-grey.png';
import '../../style/scss/account.scss';

const TwoFactorPage = () => {
    return (
        <div className='container-center'>
            <div className='account-container'>
                <img src={logoGrey} alt="Logo" className='account-logo'/>
                <div className='account-form'>
                    <TwoFactorForm />
                </div>
                <div className='account-buttons'>
                    <SecondaryButton
                        label="account.logout_button_label"
                        size="small"
                        route="/login" />
                </div>
            </div>
        </div>
    );
};

export default TwoFactorPage;